import { useState } from 'react';
import { Link, useLocation } from 'react-router-dom';

export default function Header() {
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);
  const location = useLocation();

  const navItems = [
    { name: 'Home', path: '/' },
    { name: 'Services', path: '/services' },
    { name: 'For Physicians', path: '/physicians' },
    { name: 'Physician Referral Form', path: '/referralform' },
    { name: 'Get Doctor\'s Order', path: '/doctors-order' },
    { name: 'About', path: '/about' },
    { name: 'Contact', path: '/contact' }
  ];

  const isActive = (path: string) => location.pathname === path;

  return (
    <header className="bg-white shadow-sm sticky top-0 z-50">
      <nav className="mx-auto px-6 lg:px-12 py-4">
        <div className="flex items-center justify-between">
          <Link to="/" className="flex items-center space-x-3">
            <div className="w-10 h-10 bg-[#1e3a5f] rounded-lg flex items-center justify-center">
              <i className="ri-hospital-line text-white text-2xl"></i>
            </div>
            <div className="flex flex-col">
              <span className="text-xl font-bold text-[#1e3a5f] leading-tight" style={{ fontFamily: '"Pacifico", serif' }}>Zeus</span>
              <span className="text-xs text-gray-600 leading-tight">Specialty Infusion</span>
            </div>
          </Link>

          <div className="hidden lg:flex items-center space-x-8">
            {navItems.map((item) => (
              <Link
                key={item.path}
                to={item.path}
                className={`text-base font-medium transition-colors whitespace-nowrap cursor-pointer ${
                  isActive(item.path)
                    ? 'text-[#1e3a5f] border-b-2 border-[#d4af37]'
                    : 'text-gray-700 hover:text-[#1e3a5f]'
                }`}
              >
                {item.name}
              </Link>
            ))}
            <Link
              to="/contact"
              className="bg-[#d4af37] text-[#1e3a5f] px-6 py-2 rounded-lg font-medium hover:bg-[#c19b2a] transition-colors whitespace-nowrap cursor-pointer"
            >
              Request Appointment
            </Link>
          </div>

          <button
            onClick={() => setMobileMenuOpen(!mobileMenuOpen)}
            className="lg:hidden w-10 h-10 flex items-center justify-center cursor-pointer"
          >
            <i className={`${mobileMenuOpen ? 'ri-close-line' : 'ri-menu-line'} text-2xl text-[#1e3a5f]`}></i>
          </button>
        </div>

        {mobileMenuOpen && (
          <div className="lg:hidden mt-4 pb-4 space-y-3">
            {navItems.map((item) => (
              <Link
                key={item.path}
                to={item.path}
                onClick={() => setMobileMenuOpen(false)}
                className={`block py-2 text-base font-medium transition-colors cursor-pointer ${
                  isActive(item.path) ? 'text-[#1e3a5f]' : 'text-gray-700'
                }`}
              >
                {item.name}
              </Link>
            ))}
            <Link
              to="/contact"
              onClick={() => setMobileMenuOpen(false)}
              className="block bg-[#d4af37] text-[#1e3a5f] px-6 py-2 rounded-lg font-medium text-center cursor-pointer"
            >
              Request Appointment
            </Link>
          </div>
        )}
      </nav>
    </header>
  );
}
